module.exports = __webpack_public_path__ + "img/2.5f0bd6d9.png";